import { useContext } from "react";
import { SelectedGameContext } from "./selected-game-context";

export const useSelectedGameContext = () => useContext(SelectedGameContext);
